var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen',{staticClass:"steps-view",attrs:{"size":"large"}},[_c('div',{style:({
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'column'
		})},[_c('h1',[_vm._v(" Updating a few things... You will be automatically redirected shortly. ")]),_c('p',[_vm._v(" If you are not automatically redirected, please click "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('a',[_vm._v("here")])]),_vm._v(". ")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }